import { Id } from "@dgs/core";

export const ALL_CONTACT_EMAIL_TYPES = ["private", "work", "group", "other"] as const;

export type ContactEmailType = (typeof ALL_CONTACT_EMAIL_TYPES)[number];

export type IContactEmailIndexResource = {
	id: Id;
	email: string;
	type: ContactEmailType;
	isPrimary: boolean;
};

export type IContactEmailOptionResource = IContactEmailIndexResource;

export type IContactEmailUpdateResource = IContactEmailIndexResource;

export type ContactEmailSaveRequest = Omit<IContactEmailIndexResource, "id"> & {
	contactId: Id;
};

export type IContactEmailFormState = Omit<IContactEmailUpdateResource, "id">;
